import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _inherits from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
import { v1 as uuid } from 'uuid';
import MessageProvider, { MessageType } from './MessageProvider';

var ConfirmationMessageProvider = /*#__PURE__*/function (_MessageProvider) {
  _inherits(ConfirmationMessageProvider, _MessageProvider);

  var _super = _createSuper(ConfirmationMessageProvider);

  function ConfirmationMessageProvider() {
    var _this;

    _classCallCheck(this, ConfirmationMessageProvider);

    _this = _super.apply(this, arguments);
    _this.confirmationResolvers = {};

    _this.sendWithConfirmation = function (message) {
      if (!_this.targetOrigin) {
        throw Error('target origin is not defined');
      }

      _this.subscribeOnConfirmation();

      var uuidValue = uuid();
      message.uuid = uuidValue;

      _this.send(message);

      return new Promise(function (resolve, reject) {
        _this.confirmationResolvers[uuidValue] = resolve;
        setTimeout(function () {
          if (_this.confirmationResolvers[uuidValue]) {
            delete _this.confirmationResolvers[uuidValue];
            reject(Error('timeout expired'));
          }
        }, 10000);
      });
    };

    _this.destroy = function () {
      _this.unsubscribeConfirmation && _this.unsubscribeConfirmation();
    };

    _this.subscribeOnConfirmation = function () {
      if (_this.unsubscribeConfirmation) {
        return;
      }

      var handleMessage = function handleMessage(event) {
        if (event.origin === _this.targetOrigin && event.source === _this.targetWindow) {
          var message = ConfirmationMessageProvider.parseMessage(event);

          if (message.type === MessageType.CONFIRMATION && message.uuid) {
            var resolve = _this.confirmationResolvers[message.uuid];

            if (resolve) {
              delete _this.confirmationResolvers[message.uuid];
              resolve();
            }
          }
        }
      };

      window.addEventListener('message', handleMessage, false);

      _this.unsubscribeConfirmation = function () {
        window.removeEventListener('message', handleMessage);
        _this.unsubscribeConfirmation = undefined;
      };
    };

    return _this;
  }

  return _createClass(ConfirmationMessageProvider);
}(MessageProvider);

export { ConfirmationMessageProvider as default };